import axiosClient from './axiosClient';
import { Testimonial } from '../types';

export const getTestimonials = async (): Promise<Testimonial[]> => {
  const response = await axiosClient.get('/testimonials');
  return response.data;
};

export const createTestimonial = async (testimonial: Partial<Testimonial>): Promise<Testimonial> => {
  const response = await axiosClient.post('/testimonials', testimonial);
  return response.data;
};

export const updateTestimonial = async (testimonial: Testimonial): Promise<Testimonial> => {
  const response = await axiosClient.put(`/testimonials/${testimonial._id}`, testimonial);
  return response.data;
};

export const deleteTestimonial = async (id: string): Promise<void> => {
  await axiosClient.delete(`/testimonials/${id}`);
};
